import { PathLayerProps, PolygonLayerProps } from "@deck.gl/layers";
import { useSelector } from "react-redux";

import { XYLocation } from "@nens/deck-gl";

import { appDispatch } from "../../App";
import { getExistingRasterEdits } from "../../state/existingEvents";
import { getPoints, getStatus, setPointsAction, setStatusAction } from "../../state/polygonEdit";

import { STATIC_COLORS } from "./DeckGlConsts";
import { DrawPolygon } from "./helpers/DrawPolygon";

// Line / Levee edit tool. Shown when the levee edit edit tool is open; what it does depends
// on Redux state.

const useRasterEditTool = () => {
  const polygon = useSelector(getPoints);
  const status = useSelector(getStatus);

  const setCallback = (polygon: XYLocation[]) => appDispatch(setPointsAction(polygon));
  const removeLastPointCallback = () => {
    if (!polygon) return;
    if (polygon.length > 2) {
      appDispatch(setPointsAction(polygon.slice(0, -1)));
    } else {
      appDispatch(setPointsAction(null));
      appDispatch(setStatusAction("SELECT_OR_NEW"));
    }
  };

  const confirmDrawingCallback = () => {
    appDispatch(setStatusAction("NEED_CONFIRMATION"));
  };

  const defaultPathLayerProps = {
    widthMaxPixels: 15,
    positionFormat: `XY`,
    _pathType: "open",
    opacity: 1,
    capRounded: true,
    jointRounded: true,
    getPath: (d: XYLocation) => d.flat().flat(),
    getWidth: 0.5,
    widthMinPixels: 1,
    pickable: false,
    getColor: STATIC_COLORS.LEVEE_EDIT,
  };

  const defaultPolygonLayerProps = {
    lineWidthMinPixels: 1,
    getPolygon: (d: XYLocation) => d.flat().flat(),
    getElevation: 0,
    getFillColor: [...STATIC_COLORS.LEVEE_EDIT, 50],
    getLineColor: (d: XYLocation, index: number) => (index ? STATIC_COLORS.LEVEE_EDIT : undefined),
    getLineWidth: 1,
    positionFormat: "XY",
  };
  const existingRasterEdits = useSelector(getExistingRasterEdits).map(
    (edit) => edit.polygon.coordinates[0] as XYLocation[]
  );

  return DrawPolygon({
    setCallback,
    confirmDrawingCallback,
    points: polygon || undefined,
    removeLastPointCallback,
    existingRasterEdits,
    defaultPolygonLayerProps: defaultPolygonLayerProps as unknown as PolygonLayerProps,
    defaultPathLayerProps: defaultPathLayerProps as unknown as PathLayerProps,
    finished: status === "NEED_CONFIRMATION",
  });
};

export default useRasterEditTool;
